<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="classificazioneForm">
<form [formGroup]="classificazioneForm" (ngSubmit)="saveRequest();">
	<div class="row">
		<div comboModInput class="col-sm-6" [labelInput]="'Materia'"
			formControlName="materia" [mandatory]="true"
			[control]="classificazioneForm.controls['materia']"
			[optionsCombo] ="materieOptions" [objectReference]="request.materia"
			(onReturn)="changedMateriaSelected($event)" [ngModel]="request.materia"></div>

		<div comboModInput class="col-sm-6" [labelInput]="'Oggetto'"
			formControlName="oggetto" [mandatory]="true"
			[submitPending]="!request.materia" [optionsCombo] ="oggettiOptions"
			[control]="classificazioneForm.controls['oggetto']"
			[objectReference]="request.oggetto"
			(onReturn)="changedOggettoSelected($event)"></div>
	</div>
	<div class="row">
		<div comboModInput class="col-sm-6" [labelInput]="'Argomento'"
			formControlName="argomento"
			[submitPending]="!request.oggetto || !request.materia"
			[optionsCombo] ="argomentiOptions"
			[objectReference]="request.argomento"
			(onReturn)="changedArgomentoSelected($event)"></div>

		<div checkBoxRadio class="col-sm-6"
			[labelInput]="'Imposta come principale'"
			formControlName="isPrincipale" idInput="isPrincipale" [submitPending]="!canCheckPrimary()"
			[objectReference]="request.isPrincipale"
			(onReturn)="request.isPrincipale = $event">
		</div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm()">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="getClassificazione() ? 'Salva': 'Inserisci e salva'" [disabled]="!request.oggetto || !request.materia"></p>
	</div>
</form>
</ng-template>
